import 'whatwg-fetch';

import { config, fake, get, post, put, httpDelete, postFormData } from './rest-api-calls';
import { getThunk, postThunk, putThunk, deleteThunk, shouldExecute } from './dispatch-thunk';
import { fetchActions } from './fetch-actions';
import { apiCallReducer, ApiCallState } from './fetch-reducer';

export {
  config,
  fake,
  get,
  post,
  put,
  httpDelete,
  postFormData,
  getThunk,
  postThunk,
  putThunk,
  deleteThunk,
  shouldExecute,
  fetchActions,
  apiCallReducer,
  ApiCallState,
}



// WEBPACK FOOTER //
// src/api/index.js